import posthog from 'posthog-js'

// PostHog: product analytics. Three privacy/cost choices worth knowing:
//   - autocapture: false                 — ONLY events we explicitly fire
//   - disable_session_recording: true    — no DOM recordings; opt-in later
//   - person_profiles: 'identified_only' — anon users don't create profiles,
//     so the free 1M-events tier covers signed-in usage rather than every
//     landing-page bounce.

const KEY  = import.meta.env.VITE_POSTHOG_KEY
const HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

export function initPostHog() {
  if (!KEY) {
    console.warn('PostHog key not configured — skipping init')
    return
  }

  posthog.init(KEY, {
    api_host:                  HOST,
    person_profiles:           'identified_only',
    capture_pageview:          true,
    capture_pageleave:         true,
    autocapture:               false,
    disable_session_recording: true,
    loaded: (ph) => {
      if (import.meta.env.MODE === 'development') ph.debug()
    },
  })
}

// Connect an anonymous PostHog session to a real user — call ONLY after
// successful auth so we don't pollute the user table with pre-signup
// distinctIds.
export function identifyUser(user: { id: string; email?: string; household_id?: string }) {
  posthog.identify(user.id, {
    email:        user.email,
    household_id: user.household_id,
  })
}

// Disconnect on sign-out so the next user on this device gets a fresh
// distinctId rather than inheriting the previous user's identity.
export function resetUser() {
  posthog.reset()
}

export function track(event: string, properties?: Record<string, unknown>) {
  posthog.capture(event, properties)
}

export { posthog }
